import axios from 'axios'
import store from '../store'
import { Notify, Loading, QSpinnerIos } from 'quasar'
const appID = 'crm'
const service = axios.create({
  timeout: 40000 // 統一timeout設定
})
// before request
service.interceptors.request.use(config => {
  Loading.show({
    spinner: QSpinnerIos,
    spinnerSize: '4em'
  })
  if (store.getters.token) config.headers['x-app-token'] = store.getters.token
  if (store.getters.devtoken !== null) config.headers['x-dev-token'] = store.getters.devtoken
  config.headers['x-app-id'] = appID
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})
// after response
service.interceptors.response.use(
  response => {
    Loading.hide()
    const res = response.data
    if (res.errors) {
      return Promise.reject(res)
    } else {
      return res
    }
  },
  error => {
    Loading.hide()
    Notify.create({
      message: error.message
    })
    return Promise.reject(error)
  }
)
export default service
